// @module Tekyard.PDPSerialLotFunctionality.SerialLotData
define('C3.PDPSerialLotFunctionality.SerialLotData.PDView'
,	[
	'tekyard_pdpseriallotfunctionality_seriallotdata_pdview.tpl',
	'C3.PDPSerialLotFunctionality.SerialLotData.PDView.Model',
	'C3.PDPSerialLotFunctionality.SerialLotData.PDSkeleton',
	'LiveOrder.Model',
	'Utils',
	'C3.Utils.CartUtils',
	'C3.PD.InventoryImages.View',
	'C3.PDPSerialLotFunctionality.SerialLotData.PDHighlightsView',
	'C3.PDPSerialLotFunctionality.SerialLotData.InfoTooltip',
	'Backbone.CollectionView',
	'facets_items_collection_view_cell.tpl',
    'facets_items_collection_view_row.tpl',
    'facets_items_collection.tpl',
    'Handlebars'
   
    ]
, function (
	tekyard_pdpseriallotfunctionality_seriallotdata_pdview_tpl,
	SerialLotPDModel,
	PDSkeletonView,
	LiveOrderModel,
	Utils,
	CartUtils,
	PDInventoryImagesView,
	PDHighlightsView,
	InfoTooltip,
	BackboneCollectionView,
	facets_items_collection_view_cell_tpl,
    facets_items_collection_view_row_tpl,
    facets_items_collection_tpl,
    Handlebars
	
)
{
    'use strict';

	// @class C3.PDPSerialLotFunctionality.SerialLotData.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_seriallotdata_pdview_tpl

	,	initialize: function (options) {
		    this.options = options;    
		    this.application = options.application;
		    this.inventoryid = options.inventoryid;
		    this.item = options.item;
		    this.cosmeticname = options.cosmeticname;
		    this.functionalname = options.functionalname;
		    this.location = options.location;
		    this.locationid = options.locationid;  
		    this.saleprice = options.saleprice;
		    this.notes = options.notes;
		    this.video360 = options.video360;
		    this.model = new SerialLotPDModel();
		    this.parentView = options.parentView;
		    this.isLoading = true;
		    this.invtimg = options.invtimg;
		    this.AINinternalid = options.AINinternalid;
		    this.origin = options.origin;
		    this.model.set('inventoryimages', []);

		    this.selectedSerial = options.selectSerial;

		    var self = this;
		    this.model.fetch({
		        data: { inventoryimageid: this.AINinternalid }
		    }).done(async () => {
			    self.isLoading = false;

			    // Wait until refreshCartStatus finishes
			    await self.refreshCartStatus();

			    self.render();
			});

		    this.itemExistsInCart = false;

		    // Init info-icon tooltips (Cosmetic / Functional in the product-detail pane)
		    // on every render. Bind with .on so it survives re-renders (view re-renders
		    // after the model fetch completes and again when a different serial is picked).
		    this.on('afterViewRender', function () {
		        InfoTooltip.initInfoTooltips(this.$el);
		    });
		}

	,   refreshCartStatus: async function () {

	    const exists = await CartUtils.isItemInCart(
	        this.application,
	        this.origin === 'plp' ? this.item.get('internalid') : this.item.internalid,
	        { custcol_internalassettag: this.inventoryid }
	    );
	    //console.log(!!exists)
	    this.itemExistsInCart = !!exists;
	    //this.updateCartButtonUI();
	}



	,	events: {
		 'click [data-action="add-serial-to-cart"]': 'addSerialToCart',
   		 'click [data-action="remove-serial-from-cart"]': 'removeSerialFromCart'
		}
		

	,	bindings: {
		}

	,   cleanField: function cleanField(val) {
		    if (!val) {
		        return '';
		    }

		    return String(val)
		        .replace(/&nbsp;/g, ' ')     // entity form
		        .replace(/\u00A0/g, ' ')     // actual NBSP char
		        .trim();
		}
	

	, 	childViews: {
        'SerialLotPD.Highlights': function () {
            //return new PDHighlightsView();
        	var isPhoneDevice = Utils.isPhoneDevice()
			,   viewsPerRow = 4;

			if(isPhoneDevice)
			viewsPerRow = 2;

			
		    //console.log(highlights.length)
            return new BackboneCollectionView({
                collection: this.highlights,
                viewsPerRow: viewsPerRow,
               // childTemplate: facets_item_cell_grid_tpl,
                childView: PDHighlightsView,
                cellTemplate: facets_items_collection_view_cell_tpl,
                rowTemplate: facets_items_collection_view_row_tpl,
                template: facets_items_collection_tpl
            });

        },
        'SerialLotPD.Skeleton': function () {
            return new PDSkeletonView();
        },
        'Inventory.Images.List': function(){
        	var imagesList = this.model.get('inventoryimages')
        	var images = imagesList.map(function (img) {
			    return {
			        type: 'image',
			        url: img.url,
			        inventorynumber: img.inventorynumber
			    };
			});

			var viewer360Url = this.video360;		
			var viewer360Thumb = '/SSP Applications/AAMedicalStore/AAMedicalStore/img/video-thumbnail.png';
			if(viewer360Url && viewer360Url !== '- None -')
			{
				images.unshift({
				    type: 'html360',
				    url: viewer360Url,
				    thumbUrl: viewer360Thumb
				});
			}

    		return new PDInventoryImagesView({
    		inventoryimages : images,
    		model:this.model
    		});
        }
    }

    ,   removeSerialFromCart: function (e) {
	        var $element = jQuery(e.currentTarget);
	        var assetid = $element.attr('data-asset');
	        var self = this;

	        $element.prop('disabled', true).text('Removing...');

	        CartUtils.removeItemFromCart(
	            self.application,
	            self.origin === 'plp' ? self.item.get('internalid') : self.item.internalid,
	            { custcol_internalassettag: assetid }
	        ).then(function (removed) {
	            if (removed) {
	                // update flag
	                self.itemExistsInCart = false;

	                // refresh cart status + re-render
	                self.refreshCartStatus().then(() => {
	                    self.render();
	                });

	                if (self.parentView) {
	                    self.parentView.trigger('serial:removed', {
	                        removed: assetid,
	                        current: self.inventoryid
	                    });
	                }
	            } else {
	                $element.text('Error').prop('disabled', false);
	            }
	        });
    }

    ,  getBaseDomainFromImageUrl: function getBaseDomainFromImageUrl(url) {
		  if (!url) return null;

		  var domain = window.location.origin;

		  // Add protocol if missing
		  if (!/^https?:\/\//i.test(url)) {
		    url = domain + url;
		  }

		  try {
		    return url;
		  } catch (e) {
		    return null;
		  }
		}


    ,   addSerialToCart: function addSerialToCart(e)
    	{
    		var $element = jQuery(e.currentTarget)
    		,   itemId = $element.attr('data-item')
    		,   serialAsset = $element.attr('data-asset')
    		,   serialPrice = $element.attr('data-price')
    		,   serialImgUrl = $element.attr('data-url')
    		,   dataCosmetic = $element.attr('data-cosmetic')
    		,   dataFunctional = $element.attr('data-functional')
    		,   dataDisposable = $element.attr('data-disposable')

    		var getUrl = this.getBaseDomainFromImageUrl(serialImgUrl);
    		//console.log(getUrl)

    		var linesData = {
	            assettag: serialAsset || '',
	            imgurl: serialImgUrl,
	            location: this.locationid,
	            price: serialPrice     
	        };

	        // Disposable items have no functional/cosmetic - just disposable condition
	        if (dataDisposable) {
	            linesData.disposable = dataDisposable;
	        } else {
	            linesData.functional = dataFunctional;
	            linesData.cosmetic = dataCosmetic;
	        }

    		var self = this;
    		var cart = this.application.getComponent('Cart');
    		var liveOrder = LiveOrderModel.getInstance();
    		$element.prop('disabled', true).text('Processing...');
    		cart.addLine({
            line: {
                    quantity: parseFloat(1),
                    item: {internalid: parseFloat(itemId)},
                    options:[{
                    "value":{"label": serialAsset,"internalid": serialAsset},
                    "cartOptionId": "custcol_internalassettag",
                    "label": "Asset Tag"
                    },{
                    "value":{"label": JSON.stringify(linesData),"internalid": JSON.stringify(linesData)},
                    "cartOptionId": "custcol_webstore_temp_data",
                    "label": "SerialImage"
                    }]
                }
            }).done(function(e) {
                SC.loadingIndicatorHide();
               // $element.text('Added to Cart'); 

                if (self.parentView) {
				    self.parentView.trigger('serial:added', {
				        current: self.inventoryid 
				    });
				}
				self.itemExistsInCart = true;
				self.render();
            });
    	}

    ,  cleanNoneValues : function cleanNoneValues(obj) {
		    var cleaned = {};
		    
		    for (var key in obj) {
		        if (obj.hasOwnProperty(key)) {
		            var value = obj[key];
		            
		            // Replace "- None -" with empty string
		            if (value === '- None -') {
		                cleaned[key] = '';
		            } else {
		                cleaned[key] = value;
		            }
		        }
		    }
		    
		    return cleaned;
		}
	

		//@method getContext @return Tekyard.PDPSerialLotFunctionality.SerialLotData.View.Context
	,	getContext: function getContext()
		{
			//console.log(this)

		    var cleanedItem = this.cleanNoneValues(this.selectedSerial);
		    //console.log(cleanedItem)

			this.highlights = [
				{
		            name: 'Date of Manufacturer',
		            value: cleanedItem.dateofmanufacturer
		        },
		        {
		            name: 'Software Version',
		            value: cleanedItem.softwareversion
		        },
		        {
		            name: 'Pixels',
		            value: cleanedItem.pixels
		        },
		        {
		            name: 'Hours Operated',
		            value: cleanedItem.hoursoperated
		        },
		        {
		            name: 'Broken Fibers',
		            value: cleanedItem.brokenfibers
		        },
		        {
		            name: ' Cycle Count',
		            value: cleanedItem.cyclecount
		        },
		        {
		            name: 'Compatibility',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_compatible_with')) : this.cleanField(this.item.custitem_compatible_with)
		        },
		        {
		            name: 'Diameter',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_diameter')) : this.cleanField(this.item.custitem_diameter)
		        },
		        {
		            name: 'Angle',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_angle')) : this.cleanField(this.item.custitem_angle)
		        },
		        {
		            name: 'Locking Mechanism',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem117')) : this.cleanField(this.item.custitem117)
		        },
		        {
		            name: 'Sterilization',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem118')) : this.cleanField(this.item.custitem118)
		        },
		        {
		            name: 'Working Length',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem116')) : this.cleanField(this.item.custitem116)
		        },
		        {
		            name: 'Camera Sterilization',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem152')) : this.cleanField(this.item.custitem152)
		        },
		        {
		            name: 'Monitor: Size',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_monitor_size')) : this.cleanField(this.item.custitem_monitor_size)
		        },
		        {
		            name: 'Instrument Type',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_instrument_type')) : this.cleanField(this.item.custitem_instrument_type)
		        },
		        {
		            name: 'Drill Power',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_type_of_drill')) : this.cleanField(this.item.custitem_type_of_drill)
		        },
		        {
		            name: 'Drill Type',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem36')) : this.cleanField(this.item.custitem36)
		        },
		        {
		            name: 'Attachment Series',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_type_of_attachment')) : this.cleanField(this.item.custitem_type_of_attachment)
		        },
		        {
		            name: 'Ortho: Bur Diameter',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem91')) : this.cleanField(this.item.custitem91)
		        },
		        {
		            name: 'Ortho: Type of Blade',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem92')) : this.cleanField(this.item.custitem92)
		        },
		        {
		            name: 'Ortho: Bur Shape',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem93')) : this.cleanField(this.item.custitem93)
		        },
		        {
		            name: 'Ortho: Bur Type',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_ortho_bur_type')) : this.cleanField(this.item.custitem_ortho_bur_type)
		        },
		        {
		            name: 'Blade Thickness',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem112')) : this.cleanField(this.item.custitem112)
		        },
		        {
		            name: 'Cut Depth',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem113')) : this.cleanField(this.item.custitem113)
		        },
		        {
		            name: 'Cut Edge',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem111')) : this.cleanField(this.item.custitem111)
		        },
		        {
		            name: 'Width',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem45')) : this.cleanField(this.item.custitem45)
		        },
		        {
		            name: 'Blade Diameter',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_blade_diameter')) : this.cleanField(this.item.custitem_blade_diameter)
		        },
		        {
		            name: 'Arthro: Blade/Bur Type',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem_arthro_bladebur_type')) : this.cleanField(this.item.custitem_arthro_bladebur_type)
		        },
		        {
		            name: 'Instrument Length',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem87')) : this.cleanField(this.item.custitem87)
		        },
		        {
		            name: 'Aspect Ratio',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem67')) : this.cleanField(this.item.custitem67)
		        },
		        {
		            name: 'Product Generation/System',
		            value: this.origin === 'plp' ?  this.cleanField(this.item.get('custitem169')) : this.cleanField(this.item.custitem169)
		        }
		    ];

		    // optional: filter out empty ones
		    this.highlights = _.filter(this.highlights, function (h) {
		        return h.value && h.value !== '';
		    });

		    //console.log(this.item)

		    if(this.notes === '- None -')
		    	this.notes = '';
		    
			return {
        		hasHighlights: this.highlights.length > 0,
				isLoading: this.isLoading,
				inventoryNumberImage : this.invtimg,
				asset : this.inventoryid,
				itemExistsInCart : this.itemExistsInCart,
				displayName:this.origin === 'plp' ? this.item.get('displayname') : this.item.displayname,
				warrantyInfo:this.origin === 'plp' ? this.item.get('custitem_website_warranty') : this.item.custitem_website_warranty,
				itemid: this.origin === 'plp' ? this.item.get('internalid') : this.item.internalid,
				manufacturer: this.origin === 'plp' ? this.item.get('manufacturer') : this.item.custitem_manufacturer,
				location : this.location,
				notes : this.notes,
				isPhoneDevice : Utils.isPhoneDevice(),
				salePrice: this.saleprice,
				cosmeticName : this.origin === 'plp' ?  this.cosmeticname.value : this.cosmeticname.label,
				functionalName : this.origin === 'plp' ?  this.functionalname.value : this.functionalname.label
			};
		}
	});
});
